<template>

    <div class="min-h-screen bg-slate-100 pb-12">
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog class="relative z-50 lg:hidden" @close="sidebarOpen = false">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300"
                                 enter-from="opacity-0" enter-to="opacity-100"
                                 leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
                                 leave-to="opacity-0">
                    <div class="fixed inset-0 bg-slate-950/70 backdrop-blur-sm"/>
                </TransitionChild>

                <div class="fixed inset-0 flex min-h-0">
                    <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                                     enter-from="-translate-x-full" enter-to="translate-x-0"
                                     leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                                     leave-to="-translate-x-full">
                        <DialogPanel class="relative mr-16 flex min-h-0 w-full max-w-xs flex-1">
                            <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                                             enter-to="opacity-100" leave="ease-in-out duration-300"
                                             leave-from="opacity-100" leave-to="opacity-0">
                                <div class="admin-mobile-sidebar-close absolute left-full top-0 flex w-16 justify-center pt-5">
                                    <button type="button" class="-m-2.5 p-2.5" @click="sidebarOpen = false">
                                        <span class="sr-only">{{ t('common.close_sidebar') }}</span>
                                        <XMarkIcon class="size-6 text-white" aria-hidden="true"/>
                                    </button>
                                </div>
                            </TransitionChild>
                            <!-- Barra laterale mobile -->
                            <div class="flex min-h-0 grow flex-col border-r border-white/10 bg-gradient-to-b from-indigo-950 via-indigo-900 to-indigo-900 pb-6 pl-6 pr-1 shadow-2xl">

                                <div class="admin-mobile-sidebar-scroll admin-sidebar-menu-scroll -ml-2 min-h-0 flex-1 overflow-x-hidden overflow-y-auto pl-2 pr-3 pt-6">
                                    <!--
                                    <form class="mb-4" action="#" method="GET">
                                        <label for="mobile-sidebar-search" class="sr-only">Cerca</label>
                                        <input
                                            id="mobile-sidebar-search"
                                            type="search"
                                            name="search"
                                            class="block w-full rounded-lg border border-white/10 bg-white/10 px-3 py-2 text-sm text-white placeholder:text-indigo-200/70 focus:border-indigo-200/60 focus:outline-none focus:ring-2 focus:ring-indigo-200/20"
                                            placeholder="Cerca"
                                        />
                                    </form>
                                    -->

                                    <Menu></Menu>
                                </div>

                                <AdminSidebarUserMenu class="-ml-2 mr-[15px] mt-4 shrink-0" />
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Barra laterale desktop -->
        <div
            class="hidden lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:flex lg:min-h-0 lg:flex-col lg:transition-[width] lg:duration-200 lg:ease-out"
            :class="desktopSidebarExpanded ? 'lg:w-64' : 'lg:w-[4.75rem]'"
            @mouseenter="sidebarHovered = true"
            @mouseleave="sidebarHovered = false"
        >
            <!-- Navigazione laterale desktop -->
            <div
                class="flex min-h-0 grow flex-col border-r border-white/10 bg-gradient-to-b from-indigo-950 via-indigo-900 to-indigo-900 px-3 pb-6 shadow-2xl"
            >

                <div class="flex shrink-0 pt-4">
                    <button
                        type="button"
                        class="group relative grid h-9 items-center overflow-hidden rounded-xl text-xs font-semibold text-indigo-100/85 transition-colors hover:text-white"
                        :class="desktopSidebarExpanded ? 'w-full grid-cols-[3.25rem_minmax(0,1fr)]' : 'mx-1 w-11 grid-cols-[2.75rem_minmax(0,0fr)]'"
                        :aria-label="sidebarPinLabel"
                        :title="sidebarPinLabel"
                        @click="toggleSidebarPinned"
                    >
                        <span
                            :class="getSidebarPinFrameClass()"
                            aria-hidden="true"
                        ></span>
                        <component :is="sidebarPinned ? LockClosedIcon : LockOpenIcon" class="relative z-10 col-start-1 size-4 shrink-0 justify-self-center" aria-hidden="true" />
                        <span
                            class="relative z-10 min-w-0 truncate pr-2 text-left transition-[opacity,transform] duration-150 ease-out"
                            :class="desktopSidebarExpanded ? 'translate-x-0 opacity-100' : 'pointer-events-none translate-x-1 opacity-0'"
                        >
                            {{ sidebarPinned ? t('common.sidebar_pinned') : t('common.pin_sidebar') }}
                        </span>
                    </button>
                </div>

                <div
                    class="admin-sidebar-menu-scroll min-h-0 flex-1 overflow-x-hidden overflow-y-auto px-0 pt-5"
                    :class="desktopSidebarExpanded ? '' : 'admin-sidebar-menu-scroll--collapsed'"
                >
                    <!--
                    <form class="mb-4" action="#" method="GET">
                        <label for="desktop-sidebar-search" class="sr-only">Cerca</label>
                        <input
                            id="desktop-sidebar-search"
                            type="search"
                            name="search"
                            class="block w-full rounded-lg border border-white/10 bg-white/10 px-3 py-2 text-sm text-white placeholder:text-indigo-200/70 focus:border-indigo-200/60 focus:outline-none focus:ring-2 focus:ring-indigo-200/20"
                            placeholder="Cerca"
                        />
                    </form>
                    -->

                    <Menu :collapsed="!desktopSidebarExpanded" fixed-rail></Menu>
                </div>

                <AdminSidebarUserMenu
                    :collapsed="!desktopSidebarExpanded"
                    fixed-rail
                    class="mt-4 shrink-0"
                />
            </div>
        </div>

        <div
            class="transition-[padding-left,padding-right] duration-200 ease-out"
            :class="[
                sidebarPinned ? 'lg:pl-64' : 'lg:pl-[4.75rem]',
                chatSidebarActive ? 'lg:pr-[420px]' : 'lg:pr-0',
            ]"
        >

            <div class="admin-topbar sticky top-0 z-40 border-b border-slate-200/80 bg-white/95 backdrop-blur">
                <div class="flex h-full items-center gap-3 px-4 py-2 sm:px-6 lg:px-8">
                    <button
                        type="button"
                        class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-transparent bg-transparent text-slate-600 transition hover:border-slate-200 hover:bg-white hover:text-slate-900 lg:hidden"
                        @click="sidebarOpen = true"
                    >
                        <span class="sr-only">{{ t('common.open_sidebar') }}</span>
                        <Bars3Icon class="size-6" aria-hidden="true"/>
                    </button>

                    <div class="min-w-0 flex-1"></div>

                    <div class="flex shrink-0 items-center gap-2">
                        <button
                            v-if="chatWidgetVisible && chatIsClosed"
                            type="button"
                            class="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-700 shadow-sm transition hover:border-indigo-200 hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
                            :aria-label="t('tamepulse.chat.floatingOpen')"
                            :title="t('tamepulse.chat.floatingOpen')"
                            @click="openChatPanel"
                        >
                            <fa-icon icon="robot" class="text-base" />
                        </button>
                        <TamepulseRequestCenter launcher-mode="inline" />
                    </div>
                </div>
            </div>

            <main class="pb-2 pt-0 lg:py-6">
                <div class="px-4 sm:px-6 lg:px-8">
                    <div
                        v-if="showEmailVerificationBanner"
                        class="mb-5 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950 shadow-sm"
                    >
                        <div class="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                            <div class="min-w-0">
                                <p class="font-semibold">{{ t('tamepulse.accountEmailVerification.title') }}</p>
                                <p class="mt-1 text-amber-900">
                                    {{ t('tamepulse.accountEmailVerification.description', { email: adminEmail }) }}
                                </p>
                            </div>
                            <button
                                type="button"
                                class="inline-flex shrink-0 items-center justify-center gap-2 rounded-md border border-amber-300 bg-white px-3 py-2 text-sm font-semibold text-amber-950 shadow-sm transition hover:bg-amber-100 disabled:cursor-not-allowed disabled:opacity-60"
                                :disabled="verificationSending"
                                @click="resendEmailVerification"
                            >
                                <fa-icon
                                    :icon="verificationSending ? 'circle-notch' : 'envelope'"
                                    class="size-4"
                                    :class="{ 'animate-spin': verificationSending }"
                                />
                                <span>{{ verificationSending ? t('tamepulse.accountEmailVerification.sending') : t('tamepulse.accountEmailVerification.resend') }}</span>
                            </button>
                        </div>
                    </div>
                    <slot></slot>
                </div>
            </main>
        </div>

        <FlashMessages
            bottom="0"
            v-model="flashMessages"
        />

        <TamepulseChatWidget />

        <!--
          <LoadingOverlay v-if="overlayVisibility" />
          -->

    </div>

</template>

<script setup>

import { computed, ref, watch } from 'vue'
import AdminSidebarUserMenu from '@/components/admin/AdminSidebarUserMenu.vue'
import TamepulseRequestCenter from '@/components/admin/tamepulse/TamepulseRequestCenter.vue'
import TamepulseChatWidget from '@/components/admin/tamepulse/chat/TamepulseChatWidget.vue'
import { useTamepulseChatWidget } from '@/composables/useTamepulseChatWidget'
import { useMutation } from '@/composables/useGlobals.js'
import { useFlashMessagesStore } from '@jinkosoft/flash-messages'
import { gql } from 'graphql-tag'

import {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'

import {
    Bars3Icon,
    LockClosedIcon,
    LockOpenIcon,
    XMarkIcon,
} from '@heroicons/vue/24/outline'

const SIDEBAR_PINNED_STORAGE_KEY = 'admin.sidebar.pinned'

const { t } = useI18n()
const sidebarOpen       = ref(false)
const sidebarHovered    = ref(false)
const sidebarPinned     = ref(readSidebarPinnedPreference())
const verificationSending = ref(false)
const adminAuthStore = useAdminAuthStore()
const {
    flashMessages,
    addMessage: addFlashMessage,
} = useFlashMessagesStore()
const {
    sidebarActive: chatSidebarActive,
    widgetVisible: chatWidgetVisible,
    isClosed: chatIsClosed,
    openPanel: openChatPanel,
    setWorkspaceOffset: setChatWorkspaceOffset,
} = useTamepulseChatWidget()

const { mutate: requestEmailVerification } = useMutation(gql`
    mutation AdminRequestEmailVerification {
        adminRequestEmailVerification {
            status
            message
        }
    }
`)

const desktopSidebarExpanded = computed(() => sidebarPinned.value || sidebarHovered.value)
const sidebarPinLabel = computed(() => sidebarPinned.value ? t('common.unpin_sidebar') : t('common.pin_sidebar'))
const currentAdmin = computed(() => adminAuthStore.admin)
const adminEmail = computed(() => currentAdmin.value?.email || '')
const showEmailVerificationBanner = computed(() => currentAdmin.value?.email_verified === false)

watch(desktopSidebarExpanded, (expanded) => {
    setChatWorkspaceOffset(expanded ? '16rem' : '4.75rem')
}, { immediate: true })

const toggleSidebarPinned = () => {
    sidebarPinned.value = !sidebarPinned.value
    persistSidebarPinnedPreference(sidebarPinned.value)
}

const resendEmailVerification = async () => {
    if (verificationSending.value) {
        return
    }

    verificationSending.value = true

    try {
        const result = await requestEmailVerification()
        const payload = result?.data?.adminRequestEmailVerification
        const status = payload?.status || 'sent'

        if (status === 'verified' && currentAdmin.value) {
            adminAuthStore.setAdmin({
                ...currentAdmin.value,
                email_verified: true,
                email_verified_at: new Date().toISOString(),
            })
        }

        addFlashMessage({
            type: ['cm-alert-success'],
            message: payload?.message || t(`tamepulse.accountEmailVerification.${status}`),
        })
    } catch (error) {
        addFlashMessage({
            type: ['cm-alert-danger'],
            message: t('tamepulse.accountEmailVerification.failed'),
        })
    } finally {
        verificationSending.value = false
    }
}

const getSidebarPinFrameClass = () => {
    return [
        'pointer-events-none absolute inset-y-0 rounded-xl border border-white/10 bg-white/5 group-hover:bg-white/10',
        desktopSidebarExpanded.value ? 'left-1 right-0' : 'inset-x-0',
    ]
}

function readSidebarPinnedPreference() {
    try {
        return window.localStorage.getItem(SIDEBAR_PINNED_STORAGE_KEY) === 'true'
    } catch {
        return false
    }
}

function persistSidebarPinnedPreference(value) {
    try {
        window.localStorage.setItem(SIDEBAR_PINNED_STORAGE_KEY, value ? 'true' : 'false')
    } catch {
        // La preferenza resta disponibile solo per la sessione corrente.
    }
}
</script>

<style scoped>
.admin-layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.admin-header {
    flex-shrink: 0;
}

.admin-main {
    flex: 1;
    overflow: auto;
}

.admin-footer {
    flex-shrink: 0;
}

.admin-topbar {
    height: var(--admin-topbar-height, calc(3.5rem + var(--admin-safe-area-top, 0px)));
    padding-top: var(--admin-safe-area-top, 0px);
}

.admin-mobile-sidebar-close {
    padding-top: calc(1.25rem + var(--admin-safe-area-top, 0px));
}

.admin-mobile-sidebar-scroll {
    padding-top: calc(1.5rem + var(--admin-safe-area-top, 0px));
}

.admin-sidebar-menu-scroll {
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    scrollbar-color: rgb(165 180 252 / 0.55) rgb(49 46 129 / 0.35);
}

.admin-sidebar-menu-scroll::-webkit-scrollbar {
    width: 6px;
}

.admin-sidebar-menu-scroll::-webkit-scrollbar-track {
    border-radius: 9999px;
    background: rgb(49 46 129 / 0.35);
}

.admin-sidebar-menu-scroll::-webkit-scrollbar-thumb {
    border-radius: 9999px;
    background: rgb(165 180 252 / 0.55);
}

.admin-sidebar-menu-scroll::-webkit-scrollbar-thumb:hover {
    background: rgb(199 210 254 / 0.75);
}

.admin-sidebar-menu-scroll--collapsed {
    scrollbar-gutter: auto;
    scrollbar-width: none;
}

.admin-sidebar-menu-scroll--collapsed::-webkit-scrollbar {
    width: 0;
    height: 0;
}
</style>
